import { values, mergeWith, pickBy } from 'lodash';
import { createSelector } from 'reselect';
import { TransactionStatusEnum } from '@blockcatio/tabby-library/lib/constants';

import { PaymentStatus } from '../constants';
import createStatus from '../utilities/PaymentStatus';

const paymentStatusKeys = values(PaymentStatus);

const useLatestStatusStrategy = (localPayment, fetchedPayment) => {
  if (!localPayment) return fetchedPayment;
  if (!fetchedPayment) return localPayment;

  return {
    ...fetchedPayment,
    status: createStatus(paymentStatusKeys[
      Math.max(
        paymentStatusKeys.indexOf(localPayment.status.toString()),
        paymentStatusKeys.indexOf(fetchedPayment.status.toString()),
      )
    ]),
  };
};

const mergeSources = (local, fetched) => mergeWith({}, local, fetched, useLatestStatusStrategy);

const getMergedPayments = storeState =>
  mergeSources(storeState.payments.localPayments, storeState.payments.fetchedPayments);

export const getPayments = storeState =>
  values(getMergedPayments(storeState)).filter(p => p.transactionHash);

export const getPendingPayments = createSelector([getPayments], payments =>
  payments.filter(payment => payment.status.isPending()));

export const getRemainingPayments = createSelector([getPayments], payments =>
  payments.filter(payment => !payment.status.isPending()));

export const getById = id =>
  createSelector([getPayments], payments => payments.find(payment => payment.id === id));

export const getLocalPaymentsToDiscard = state =>
  values(pickBy(state.payments.localPayments, (localPayment, transactionHash) => {
    const fetchedPayment = state.payments.fetchedPayments[transactionHash];
    if (!fetchedPayment) {
      return false;
    }
    const localStatus = paymentStatusKeys.indexOf(localPayment.status.toString());
    const fetchedStatus = paymentStatusKeys.indexOf(fetchedPayment.status.toString());
    return fetchedStatus > localStatus;
  }));

export const getByTransactionHash = transactionHash =>
  createSelector([getPayments], payments =>
    payments.find(payment =>
      values(payment.transactions || [])
        .map(tx => tx.transactionHash)
        .indexOf(transactionHash) !== -1));

export const getPendingTransactions = storeState =>
  values(storeState.payments.localPayments).reduce(
    (hashes, payment) =>
      hashes.concat(values(payment.transactions)
        .filter(transaction => transaction.status === TransactionStatusEnum.processing)
        .map(transaction => transaction.transactionHash)),
    [],
  );



// WEBPACK FOOTER //
// ./src/selectors/payments.js